import { useRef as w, useCallback as y, useEffect as g, useState as u, useMemo as X } from "react";
import { c as M } from "../../index-226b8ea6.js";
import { d as Y, i as Z, q as $, l as B } from "../../floating-ui.react-5e63cf1f.js";
import { getLocationSuggestions as V } from "./LocationPicker.api.es.js";
import { getValue as P } from "./LocationPicker.utils.es.js";
import { i as ee } from "../../isEqual-24663bfb.js";
import { b as te, f as se, o as oe, s as ne } from "../../floating-ui.dom-55cf142e.js";
function re(i, t) {
  t === void 0 && (t = 0);
  var o = w(!1), s = w(), f = w(i), c = y(function() {
    return o.current;
  }, []), l = y(function() {
    o.current = !1, s.current && clearTimeout(s.current), s.current = setTimeout(function() {
      o.current = !0, f.current();
    }, t);
  }, [t]), n = y(function() {
    o.current = null, s.current && clearTimeout(s.current);
  }, []);
  return g(function() {
    f.current = i;
  }, [i]), g(function() {
    return l(), n;
  }, [t]), [c, n, l];
}
function ie(i, t, o) {
  t === void 0 && (t = 0), o === void 0 && (o = []);
  var s = re(i, t), f = s[0], c = s[1], l = s[2];
  return g(l, o), [f, c];
}
const ge = ({
  error: i,
  inputProps: t,
  isError: o = !1,
  isSmartData: s,
  isSmartDataLoading: f,
  mapBox: c,
  onAbort: l,
  onChange: n,
  onError: q,
  onRetry: Q,
  value: d
}) => {
  const [p, E] = u(""), [L, F] = u(!1), [S, k] = u(!1), [x, O] = u(!1), [R, h] = u(!1), [r, v] = u(P(d)), [a, m] = u([]), [D, T] = u(
    d
  ), A = btoa(Math.random().toString()), C = y(
    (e) => {
      const b = !!(!e && a.length);
      h(e), F(b), b && l && l();
    },
    [r, a]
  );
  ie(
    () => {
      r !== P(D) && r !== d && E(r);
    },
    500,
    [r]
  );
  const { refs: H, floatingStyles: U, context: I } = Y({
    whileElementsMounted: te,
    open: R,
    onOpenChange: C,
    placement: "bottom-start",
    middleware: [se(), oe(6), ne()]
  }), _ = Z(I, { bubbles: !0 }), j = $(I, {
    enabled: !!a.length
  }), { getReferenceProps: z, getFloatingProps: G } = B([_, j]), J = y(async () => {
    try {
      if (O(!0), "accessToken" in c) {
        const { suggestions: e } = await V({
          accessToken: c.accessToken,
          query: p,
          sessionToken: c.sessionToken ?? A
        });
        m(e), k(!e.length);
      } else {
        const { suggestions: e } = await c.getLocationSuggestions(p);
        m(e), k(!e.length);
      }
    } catch {
      m([]), k(!0);
    } finally {
      O(!1);
    }
  }, [p]), K = () => {
    n == null || n(null), v(""), T(""), k(!1), F(!1), E(""), m([]);
  }, N = (e) => {
    const b = P(e);
    n == null || n(e), v(b), T(e), m([]);
  };
  g(() => {
    p.length && J();
  }, [p]), g(() => {
    h(!!(a != null && a.length));
  }, [a]), g(() => {
    ee(r, d) || v(P(d));
  }, [d]);
  const W = X(() => {
    let e;
    return i && (e = i), r.length && S && (e = "Invalid location"), L && (e = "Please select a valid location"), e && q && q(e), e;
  }, [r, S, L]);
  return {
    context: I,
    error: W,
    floatingStyles: U,
    getFloatingProps: G,
    getReferenceProps: z,
    hasAborted: L,
    inputProps: t,
    isEmpty: S,
    isError: o,
    isLoading: x,
    isOpen: R,
    isSmartData: s,
    isSmartDataLoading: f,
    onInputClear: K,
    onItemClick: N,
    onRetry: Q,
    query: r,
    refs: H,
    setIsOpen: h,
    setQuery: v,
    setSuggestions: m,
    setValue: T,
    suggestions: a,
    value: D
  };
}, [pe, ye] = M(), [ke, ve] = M({
  name: "LocationPickerStylesContext",
  errorMessage: `useLocationPickerStyles returned is 'undefined'. Seems you forgot to wrap the components in "<LocationPicker />" `
});
export {
  pe as LocationPickerProvider,
  ke as LocationPickerStylesProvider,
  ge as useLocationPicker,
  ye as useLocationPickerContext,
  ve as useLocationPickerStyle
};
//# sourceMappingURL=LocationPicker.context.es.js.map
